(() => {
  const isVertical = (element) => window.matchMedia('(min-width: 990px)').matches &&
    !!element.closest('product-info[id^="MainProduct-"] media-gallery[data-desktop-layout*="thumbnail"]');
  customElements.whenDefined('slider-component').then(() => {
    if (customElements.get('ori-thumbnail-slider')) return;
    customElements.define('ori-thumbnail-slider', class extends customElements.get('slider-component') {
      initPages() {
        if (!isVertical(this)) return super.initPages();
        this.sliderItemsToShow = Array.from(this.sliderItems).filter(item => item.clientWidth > 0);
        this.update();
      }
      update() {
        if (!isVertical(this)) return super.update();
        if (!this.slider || !this.prevButton || !this.nextButton) return;
        this.prevButton.disabled = this.slider.scrollTop <= 1;
        this.nextButton.disabled = this.slider.scrollTop + this.slider.clientHeight >= this.slider.scrollHeight - 1;
      }
      onButtonClick(event) {
        if (!isVertical(this)) return super.onButtonClick(event);
        event.preventDefault();
        this.slider.scrollBy({ top: (event.currentTarget.name === 'next' ? 1 : -1) * this.slider.clientHeight * .8 });
      }
      isSlideVisible(item, offset = 0) {
        if (!isVertical(this)) return super.isSlideVisible(item, offset);
        if (!item) return false;
        const a = item.getBoundingClientRect(), b = this.slider.getBoundingClientRect();
        return a.top >= b.top + offset && a.bottom <= b.bottom - offset;
      }
    });
  });

  // Only copy explicit dimension labels or numerical dimension expressions.
  function extractDimensions(text) {
    const lines = text.replace(/\u00a0/g, ' ').split(/\n+/).map(s => s.trim()).filter(Boolean);
    const number = String.raw`\d+(?:\.\d+)?`;
    const unit = String.raw`(?:\s*(?:mm|cm|metres?|meters?|inches|inch|in|ft|feet|m|["″′']))?`;
    const axis = String.raw`(?:\s*\(\s*[LWBHDØ]\s*\))?`;
    const measure = `${number}${unit}${axis}`;
    const expression = new RegExp(`${measure}(?:\\s*[x×*]\\s*${measure}){1,3}`, 'gi');
    const found = [];
    for (let i = 0; i < lines.length; i++) {
      const label = lines[i].match(/^(?:dimensions?|sizes?|measurements?)\s*[:\-–]?\s*(.*)$/i);
      if (label) {
        const value = label[1] || lines[i + 1] || '';
        if (/\d/.test(value)) found.push(value);
      } else {
        found.push(...(lines[i].match(expression) || []));
        const labelled = lines[i].match(/\b(?:height|width|length|depth|diameter)\s*[:=\-]?\s*\d+(?:\.\d+)?\s*(?:mm|cm|m|inches|inch|in|ft|["″])?\b/gi);
        if (labelled) found.push(...labelled);
      }
    }
    return [...new Set(found)].join('\n');
  }
  if (!customElements.get('ori-product-dimensions')) {
    customElements.define('ori-product-dimensions', class extends HTMLElement {
      connectedCallback() {
        const source = this.previousElementSibling;
        if (!source?.classList.contains('product__description')) return;
        const copy = source.cloneNode(true);
        copy.querySelectorAll('br').forEach(el => el.replaceWith('\n'));
        copy.querySelectorAll('p,div,li,tr,h1,h2,h3,h4').forEach(el => el.append('\n'));
        const value = extractDimensions(copy.textContent);
        this.querySelector('.ori-dimensions-content').textContent = value;
        this.hidden = !value;
      }
    });
  }
})();
